import React, {useState, useContext, useEffect} from 'react';
import { Link } from "react-router-dom";

import { FormContext } from 'context/FormContext';

import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';

import ImageButton from 'components/formElements/ImageButton';
import RadioButton from 'components/formElements/RadioButton';
import Label from 'components/formElements/Label';

import IconPlus from 'assets/images/icon_circle_plus.svg';
import IconTrash from 'assets/images/icon_trash.svg';

const ElectricCar = () => {
    const { formValues, setFormValues } = useContext(FormContext);
    const [carList, setCarList] = useState([]);

    const addCar = () => {       
        if(carList.length < 4){
            setFormValues({ ...formValues, "Cars": [...carList, 10000] });
        }
    }

    const removeCar = Car => () => {
        const newCars = [...carList];
        newCars.splice(Car, 1);
        setCarList(newCars);

        setFormValues({ ...formValues, "Cars": newCars });
    }

    const changeCar = (e) => {
        const newCars = [...carList];
        newCars[e.target.dataset.index] = parseInt(e.target.value);
        setCarList(newCars);

        setFormValues({ ...formValues, "Cars": newCars });
    }

    useEffect(() => {
            setCarList(formValues["Cars"]);
    }, [formValues]);


    return (
        <Stack gap={4} className="ContainerPaddingSmall text-center">
            <h1>Elektro-Auto hinzufügen</h1>
            <div>Fügen Sie Ihr Elektro-Auto hinzu und geben Sie die jährliche Fahrleistungen an.</div>
            <Stack>
                {carList && carList.map((car, index) => {
                    return(
                        <div key={`${index}`}>
                            <Label text="Wie hoch ist Ihre jährliche Fahrleistung?" className="" />
                            <Stack gap={4} direction="horizontal" className="mt-4 flex-wrap ">
                                <RadioButton name={"Cars[" + index + "]"} disableContextAutoSave="true" index={index} label="10.000km" sublabel="Wenig" value={10000} onChange={changeCar} checked={isCarChecked(10000, index)} />
                                <RadioButton name={"Cars[" + index + "]"} disableContextAutoSave="true" index={index} label="15.000km" sublabel="Mittel" value={15000} onChange={changeCar} checked={isCarChecked(15000, index)} />
                                <RadioButton name={"Cars[" + index + "]"} disableContextAutoSave="true" index={index} label="30.000km" sublabel="Hoch" value={30000} onChange={changeCar} checked={isCarChecked(30000, index)} />
                                <div className="pointer" onClick={removeCar(index)}><img src={IconTrash} alt="Entfernen" /> E-Auto {index+1}</div>
                            </Stack>
                            <hr />
                        </div>
                    );
                    
                })}
                <Stack gap={5} direction="horizontal" className="mt-4 ">
                    <ImageButton label="E-Auto hinzufügen" image={IconPlus} onClick={addCar} disabled={carList.length > 4} />
                </Stack>
                <hr />
                <Stack gap={3} direction="horizontal" className="mt-4 flex-column flex-md-row button-group align-items-start">
                    <Link className="order-1 order-md-0" to="/EnergyConsumption"><Button variant="outline-light">Zurück</Button></Link>
                    <Link className="order-0 order-md-1" to="/EnergyConsumption"><Button variant="success" >E-Auto Konfiguration abschließen</Button></Link>
                </Stack>
            </Stack>
        </Stack>        
    )

    function isCarChecked(value, index){
        if(carList[index] === value)
            return true;
    }
}

export default ElectricCar;